import React from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import styled from 'styled-components'
import Error404 from '../assets/404-error.png'
import SnowCamp from '../assets/snow-camp.png'
import SignUpForm from '../assets/sign-up-form.png'
import SignUpGym from '../assets/sign-up-gym.png'
import ScribeAgency from '../assets/scribe-agency.png'
import gh from 'parse-github-url'
import md5 from 'md5'
import { BsPersonSquare } from 'react-icons/bs'
import moment from 'moment'
import { Helmet } from 'react-helmet'
import Juxtapose404 from '../assets/juxtapose-404.png'
import JuxtaposeSnowCamp from '../assets/Juxtapose-Snow-Camp.png'
import JuxtaposeJoinOurGym from '../assets/Juxtapose-Join-Our-Gym.png'
import JuxtaposeSignUpForm from '../assets/Juxtapose-Sign-Up-Form.png'
import JuxtaposeScribeAgency from '../assets/Juxtapose-Scribe-Agency.png'
import JuxtaposeQuoteMachine from '../assets/Juxtapose-Quote-Machine.png'
import JuxtaposeSignUp from '../assets/Juxtapose-Sign-Up.png'
import JuxtaposeSoundJam from '../assets/Juxtapose-Sound-Jam.png'

const BookTemplate = props => {
  const {
    id,
    livesite,
    projectTitle,
    solutiontitle,
    repository,
    feedback,
    project,
    date,
  } = props.pathContext

  var API_URL = 'https://cdn.capture.techulus.in/'
  var your_api_key = '217ed509-c48b-4068-a864-cbab066a8500'
  var your_api_secret = 'ea8f4590-491f-4f21-b504-3b8da08a5ef8'
  var options = 'full=true&delay=.5'
  var input_url = encodeURIComponent(livesite)

  var full_url = input_url + '&' + options
  // var hash = md5(your_api_secret + 'url=' + input_url)
  var hash = md5(your_api_secret + 'url=' + full_url)
  return (
    <div>
      <Helmet>
        <script src="https://cdn.knightlab.com/libs/juxtapose/latest/js/juxtapose.min.js"></script>
        {/* <link
          rel="stylesheet"
          href="https://cdn.knightlab.com/libs/juxtapose/latest/css/juxtapose.css"
        /> */}
      </Helmet>
      <Hero />
      <Wrapper>
        <div className="solution-preview-container">
          {projectTitle == '404-error' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={Error404}
            />
          )}
          {projectTitle == 'quote-machine' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={JuxtaposeQuoteMachine}
            />
          )}
          {projectTitle == 'snow-camp' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={SnowCamp}
            />
          )}
          {projectTitle == 'sign-up-gym' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={SignUpGym}
            />
          )}
          {projectTitle == 'sign-up' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={JuxtaposeSignUp}
            />
          )}
          {projectTitle == 'sound-jam' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={JuxtaposeSoundJam}
            />
          )}
          {projectTitle == 'sign-up-form' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={SignUpForm}
            />
          )}
          {projectTitle == 'scribe-agency' && (
            <img
              loading="lazy"
              className="solution-preview-image"
              src={ScribeAgency}
            />
          )}
          <a href={livesite} target="_blank">
            <button className="btn solution-live-button">Live</button>
          </a>
          <button className="btn btn-solution-code" target="_blank">
            <a href={repository} target="_blank">
              Code
            </a>
          </button>
        </div>
        {/* <div> */}
        <div className="design-live-header">
          <h2 className="underline">Design</h2>
          <h2>slide to see difference</h2>
          <h2 className="underline">Live</h2>
        </div>
        <div className="juxtapose">
          {projectTitle == '404-error' && <img src={Juxtapose404} />}
          {projectTitle == 'snow-camp' && <img src={JuxtaposeSnowCamp} />}
          {projectTitle == 'sign-up-gym' && <img src={JuxtaposeJoinOurGym} />}
          {projectTitle == 'sign-up-form' && <img src={JuxtaposeSignUpForm} />}
          {projectTitle == 'sign-up' && <img src={JuxtaposeSignUp} />}
          {projectTitle == 'quote-machine' && (
            <img src={JuxtaposeQuoteMachine} />
          )}
          {projectTitle == 'scribe-agency' && (
            <img src={JuxtaposeScribeAgency} />
          )}
          <img
            src={API_URL + your_api_key + '/' + hash + '/image?url=' + full_url}
          />
        </div>
        {/* </div> */}
        <div className="avatar-and-feedback">
          <div className="avatar-and-name">
            <div className="avatar">
              {/* <BsPersonSquare /> */}
              {Object.keys(gh(repository)).map(function (key) {
                if (key === 'owner') {
                  const person = gh(repository)[key]
                  const avatarImageLink = `https://www.github.com/${person}.png?size=200`
                  return <img className="avatar-image" src={avatarImageLink} />
                }
              })}
              <img src={repository.png} />
            </div>
            <div className="avatar-name">
              {Object.keys(gh(repository)).map(function (key) {
                if (key === 'owner') {
                  return <div>{gh(repository)[key]}</div>
                }
              })}
            </div>
            {/* </div> */}
          </div>
          {/* <div>Submitted: {moment(date).format('MMMM d, YYYY')}</div> */}
          <div className="feedback-box">
            <p>Feedback: {feedback}</p>
          </div>
        </div>
        {/* </div> */}
      </Wrapper>
    </div>
  )
}

const Wrapper = styled.div`
  display: grid;
  place-items: center;
  padding: 0px 25px;
  img {
    width: 100%;
    box-shadow: 1px 1px 1px 0.5px rgba(0, 0, 0, 0.1);
  }
  .underline {
    text-decoration: underline;
  }
  .design-live-header {
    margin-top: 25px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-evenly;
    width: 100vw;
  }
  .design-live-header h2 {
    font-size: 18px;
  }
  .juxtapose {
    width: 100%;
    height: 100%;
  }
  .avatar-image {
    border-radius: 50%;
    height: 30px;
    width: 30px;
  }
  .solution-preview-container {
    position: relative;
    /* position: relative;
    width: 90%;
    height: 500px;
    margin-right: 25px;  */
  }
  .solution-preview-image {
    /* position: absolute; */
    /* width: 100%; */
    /* height: 100%; */
  }
  .solution-live-button {
    position: absolute;
    top: 10px;
    right: 25px;
    background: #fff;
    color: #000;
  }
  .solution-live-button:hover {
    color: rgba(0, 0, 0, 0.5);
  }
  .btn-solution-code {
    position: absolute;
    top: 10px;
    right: 115px;
    background: #fff;
    color: #000;
  }
  .btn-solution-code a {
    background: #fff;
    color: #000;
  }
  .btn-solution-code a:hover {
    color: rgba(0, 0, 0, 0.5);
  }
  .avatar-and-feedback {
    text-align: left;
    /* border: 2px solid blue; */
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.4);
    width: 100%;
    padding: 25px;
    margin-top: 12px;
  }
  .avatar-and-name {
    display: flex;
    margin-bottom: 12px;
    /* justify-content: space-between; */

    /* display: none; */
  }
  .avatar-profile {
    /* height: 100%;
    background-color: white;
    width: 90%;
    padding: 20px; */
  }

  .avatar {
    margin-right: 5px;
  }
  .avatar-name {
    /* color: #98a3af; */
  }
  .buttons {
    /* display: flex;
    justify-content: space-evenly;
    align-items: center; */
  }

  @media (min-width: 768px) {
    /* padding: 0 150px; */
    img {
      /* width: 65%; */
      /* box-shadow: 1px 1px 1px 0.5px rgba(0, 0, 0, 0.1); */
    }
    .design-live-header h2 {
      font-size: 30px;
    }
    .solution-preview-container {
      /* position: relative; */

      /* width: 550px; */
      /* height: 600px; */
      /* grid-area: a; */
      /* border: 2px solid yellow; */
      background: black;
    }
    .design-live-header {
      margin-top: 25px;
      margin-bottom: 25px;
      display: flex;
      justify-content: space-evenly;
      width: 100vw;
    }
    .juxtapose {
      width: 100%;
      height: 100%;
    }
    .solution-preview-image {
      /* position: absolute; */
      /* width: 100%; */
      /* height: 0%; */
      opacity: 0.75;
    }
    .solution-live-button {
      /* position: absolute; */
      /* background: purple; */
      /* top: 5px; */
      /* right: 25px; */
      /* background: #fff; */
      /* color: #000; */
    }
    .btn-solution-code {
      /* position: absolute;
      top: 5px;
      right: 105px;
      background: #fff;
      color: #000; */
    }
    .btn-solution-code a {
      /* background: #fff;
      color: #000; */
    }
    .avatar-profile {
      /* grid-area: b;
      border: 2px solid orange; */
    }
  }
`

export default BookTemplate

// import React from 'react'
// import Layout from '../components/Layout'
// import Hero from '../components/Hero'
// import styled from 'styled-components'
// import Error404 from '../assets/404-error.png'
// import SnowCamp from '../assets/snow-camp.png'
// import SignUpForm from '../assets/sign-up-form.png'
// import SignUpGym from '../assets/sign-up-gym.png'
// import gh from 'parse-github-url'
// import md5 from 'md5'
// import { BsPersonSquare } from 'react-icons/bs'

// const BookTemplate = props => {
//   console.log('Props.pathContext', props.pathContext)

//   const {
//     id,
//     livesite,
//     projectTitle,
//     solutiontitle,
//     repository,
//     feedback,
//     project,
//   } = props.pathContext
//   console.log('Repository', repository)
//   var API_URL = 'https://cdn.capture.techulus.in/'
//   var your_api_key = '217ed509-c48b-4068-a864-cbab066a8500'
//   var your_api_secret = 'ea8f4590-491f-4f21-b504-3b8da08a5ef8'
//   var options = 'full=true'
//   var input_url = encodeURIComponent(livesite)

//   var full_url = input_url + '&' + options
//   // var hash = md5(your_api_secret + 'url=' + input_url)
//   var hash = md5(your_api_secret + 'url=' + full_url)
//   return (
//     <div>
//       <Hero />
//       <Wrapper>
//         {/* {projectTitle === '404-error' && <img src={Error404} />} */}
//         {/* {projectTitle === 'snow-camp' && <img src={SnowCamp} />} */}
//         {/* {projectTitle === 'sign-up-form' && <img src={SignUpForm} />} */}
//         {/* {projectTitle === 'sign-up-gym' && <img src={SignUpGym} />} */}
//         {/* <div className="preview-container-avatar-feedback"> */}
//         {/* <div className="main-container"> */}

//         {/* <div className="main-container"> */}
//         <div className="solution-preview-container">
//           <img
//             loading="lazy"
//             className="solution-preview-image"
//             src={API_URL + your_api_key + '/' + hash + '/image?url=' + full_url}
//           />

//           {/* <div className="buttons"> */}
//           <a href={livesite} target="_blank">
//             <button className="btn solution-live-button">Live</button>
//           </a>
//           <button className="btn btn-solution-code" target="_blank">
//             <a href={repository}>Code</a>
//           </button>
//           {/* </div> */}
//           {/* </div> */}
//           {/* <div className="avatar-profile"> */}
//           <div className="avatar-and-name">
//             <div className="avatar">
//               <BsPersonSquare />
//             </div>
//             <div className="avatar-name">
//               {Object.keys(gh(repository)).map(function (key) {
//                 if (key === 'owner') {
//                   return <div>{gh(repository)[key]}</div>
//                 }
//               })}
//             </div>
//             {/* </div> */}
//           </div>
//           <div className="feedback-box">
//             <p>Feedback: {feedback}</p>
//           </div>
//           {/* <div className="underline"></div> */}
//         </div>
//         {/* </div> */}

//         {/* <p>Biggest Challenge: </p>
//       <p>Biggest Achievement: </p>
//       <p>Somethign I learned: </p>
//       <p>Something I still need to figure out: </p> */}
//       </Wrapper>
//     </div>
//   )
// }

// const Wrapper = styled.div`
//   display: grid;
//   /* background: #f8f8f8; */
//   place-items: center;
//   img {
//     width: 100%;
//     box-shadow: 1px 1px 1px 0.5px rgba(0, 0, 0, 0.1);
//     /* border-radius: 10px; */
//   }
//   .avatar-profile {
//     height: 100%;
//     background-color: white;
//     width: 90%;
//     padding: 20px;
//   }
//   .avatar-and-name {
//     display: flex;
//     margin-bottom: 12px;
//     /* justify-content: space-between; */

//     /* display: none; */
//     /* margin-top: 40px; */
//   }
//   .avatar {
//     margin-right: 5px;
//   }
//   .avatar-name {
//     color: #98a3af;
//   }
//   .buttons {
//     display: flex;
//     justify-content: space-evenly;
//     align-items: center;
//   }
//   button {
//     margin-left: 5px;
//   }
//   h3 {
//     width: 65%;
//   }
//   a {
//     color: #fff;
//   }
//   button {
//     margin: 10px 5px;
//   }
//   .underline {
//     margin: 10px 0;
//     width: 100%;
//     height: 5px;
//     background: var(--clr-primary-5);
//   }
//   .solution-preview-container {
//     /* padding: 50px; */
//     position: relative;
//     width: 90%;
//     /* height: 40vh; */
//     height: 500px;
//     /* padding: 0 250px; */
//     /* margin-left: 25px;
//     margin-right: 25px; */
//   }
//   .solution-preview-image {
//     position: absolute;
//     width: 100%;
//     /* height: 100%; */
//   }
//   .solution-live-button {
//     position: absolute;
//     /* background: purple; */
//     top: 5px;
//     right: 5px;
//     background: #fff;
//     color: #000;
//   }
//   .btn-solution-code {
//     position: absolute;
//     top: 5px;
//     right: 75px;
//     background: #fff;
//     color: #000;
//   }
//   .btn-solution-code a {
//     background: #fff;
//     color: #000;
//   }
//   @media (min-width: 768px) {
//     /* margin-top: 250px; */
//     /* .main-container { */
//     display: grid;
//     /* grid-template-areas: 'a b'; */
//     border: 2px solid purple;
//     /* grid-template-columns: 1fr 1fr; */
//     /* } */
//     img {
//       /* width: 65%; */
//       box-shadow: 1px 1px 1px 0.5px rgba(0, 0, 0, 0.1);
//     }
//     .solution-preview-container {
//       position: relative;

//       /* width: 550px; */
//       /* height: 600px; */
//       grid-area: a;
//       border: 2px solid yellow;
//     }
//     .solution-preview-image {
//       position: absolute;
//       width: 100%;
//       /* height: 0%; */
//     }
//     .solution-live-button {
//       position: absolute;
//       /* background: purple; */
//       top: 5px;
//       right: 25px;
//       background: #fff;
//       color: #000;
//     }
//     .btn-solution-code {
//       position: absolute;
//       top: 5px;
//       right: 105px;
//       background: #fff;
//       color: #000;
//     }
//     .btn-solution-code a {
//       background: #fff;
//       color: #000;
//     }
//     .avatar-profile {
//       grid-area: b;
//       border: 2px solid orange;
//     }
//   }
// `

// export default BookTemplate
